import { config } from 'process';
import { Component, OnInit } from '@angular/core';
import { OptionsInput } from 'fullcalendar';
import { locale } from 'fullcalendar';
import { timestamp } from 'rxjs/operator/timestamp';


@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss']
})
export class CalendarioComponent implements OnInit {
  config: OptionsInput;
  displayEvent: any;
  constructor() {

  }

  ngOnInit() {
      this.config = {
        editable: false,
        eventLimit: true,
        themeSystem: 'jquery-ui',
        locale: 'pt-br',
        header: {
          left: 'today,prev,next',
          center: 'title',
          right: 'month,agendaWeek,agendaDay,listMonth',
        },
        buttonText: {
          today: 'Hoje',
          month: 'Mês',
          week: 'Semana',
          day: 'Dia',
          list: 'Listar'
        },
        minTime: "07:00:00",
        maxTime: "22:00:00",
        eventRender: function(event, element, view) {
          if((view.type == 'agendaDay') || (view.type == 'listMonth')) {
            element.find('.fc-title').append("<br/>" + event.description);
          }
        },
        timezone: 'America/Sao_Paulo',
        timeFormat: 'HH:mm',
        slotLabelFormat: 'HH:mm',
        allDayText: 'Todo o dia',
        eventSources: [{
          url: 'http://cmcti.parnamirim.rn.gov.br/portal-cmcti/rest/evento/listarEventos',
          color: '#00afef',
          textColor: 'white',
        }],
        views: {
          month: {
            columnHeaderFormat: 'ddd',
          }
        },
        columnHeaderFormat: 'ddd D/M',
      };
  }

}



// WEBPACK FOOTER //
// ./src/app/portal-cmcti/calendario/calendario.component.ts